import moment from 'moment';
import { formatNumber, formatPercentage } from 'utils/number';
import numeral from 'numeral';
import { getFormattedCurrency } from 'global/Securities/utils/currencyFormatter';
import { HistoryType } from './types';

export const renderTableRowContent = (text, dataObject, children) => {
  if (dataObject.groupDate) {
    return {
      children: text,
      props: { colSpan: 0 },
    };
  }
  return children;
};

export const formatPrice = (price, replaceZero = true, decimals) => {
  const formatedPrice = formatNumber(price, false, decimals ? '0.0' : '0,0');
  return Number(formatedPrice) === 0 && replaceZero ? '-' : formatedPrice;
};

export const formatPriceRoundDown = (
  price,
  replaceZero = true,
  decimalRanges = 2,
) => {
  const decimal = '0'.repeat(decimalRanges);
  const formattedPrice = numeral(Math.floor(Number(price) * 100) / 100).format(
    `0,0[.]${decimal}`,
    Math.floor,
  );
  return Number(formattedPrice) === 0 && replaceZero ? '-' : formattedPrice;
};

/**
 * Formats a Late Fee value according to the specified rules.
 * @param {number} value - The value to format.
 * @returns {string} The formatted value as a string.
 */
export const formatCeilToDecimals = (num, fallback = '') => {
  if (num == null) return fallback;

  if (num > 1) {
    return numeral(Math.ceil(num)).format('0,0'); // Round up and format without decimals
  }

  const factor = 10 ** 2; // 2 decimals
  return numeral(Math.ceil(num * factor) / factor).format('0.[00]'); // Keep up to 2 decimals
};

export const formatDate = (date) => {
  const formatedDate = moment(date).format('D MMM YYYY');
  if (formatedDate === 'Invalid date') {
    return moment(date, 'DD/MM/YYYY').format('D MMM YYYY');
  }
  return formatedDate;
};

export const getRealizedPnLText = (dataObject, decimals = 0) => {
  const prefixAmount = dataObject.realized_amount > 0 ? '+' : '';
  const prefixPercentage = dataObject.realized_percentage > 0 ? '+' : '';
  const amount = decimals
    ? formatPriceRoundDown(dataObject.realized_amount, false, decimals)
    : formatPrice(dataObject.realized_amount, false, decimals);
  const percentage = formatPercentage(dataObject.realized_percentage, false);
  const isDividend = dataObject.command === HistoryType.DIVIDEND;
  const isSellFR = dataObject.command === HistoryType.SELL_FR;
  const isCouponFR = dataObject.command === HistoryType.COUPON_FR;
  const isCapitalReduction =
    dataObject.command === HistoryType.CAPITAL_REDUCTION;

  if (!isDividend && !isSellFR && !isCouponFR && !isCapitalReduction) {
    return `${prefixAmount}${amount} (${prefixPercentage}${percentage})`;
  }
  return `${prefixAmount}${amount}`;
};

export const addPrefixAfterPlusMinusNotation = (value = 0) => {
  const price = Math.abs(value);
  return getFormattedCurrency(price);
};

export const addPlusMinusIndicator = (value = 0) => {
  let indicator = '';
  if (value > 0) {
    indicator = '+';
  }
  if (value < 0) {
    indicator = '-';
  }

  return indicator;
};
